import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { WordTemplateActivityPanel } from "WordTemplate/activity/WordTemplateActivityPanel";
import { WordTemplateDetailSection } from "WordTemplate/WordTemplateDetailSection";
import WordTemplateOptionsPanel from "WordTemplate/WordTemplateOptionsPanel";
import { useLoaderData } from "react-router";
import { SingleSectionRightSideNavigation } from "components/RightSideNavigation/SingeSectionRightSideNavitagion";

const WordTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.WordTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <WordTemplateDetailSection
            wordTemplate={viewModel.wordTemplate}
            displayVisibleToExternal={viewModel.displayVisibleToExternal}
            displayReadyForESign={viewModel.displayReadyForESign}
            displayVisibleBookkeeping={viewModel.displayVisibleBookkeeping}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <WordTemplateOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            wordTemplateId={viewModel.wordTemplate.wordTemplateId}
          />
          <SingleSectionRightSideNavigation
            optionMenuGroup={viewModel.availableMergeFields}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
          <WordTemplateActivityPanel
            fileId={viewModel.wordTemplate.fileId}
            config={viewModel.activityPanelConfig}
            wordTemplateId={viewModel.wordTemplate.wordTemplateId}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default WordTemplateDetailApp;